export default __webpack_public_path__ + "430422344ca5d06d71e830b43ba0d2fe.svg";